import BaseModel from './BaseModel';

export default class Outlet extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.propertyId = data.propertyId || undefined;
        this.propertyName = data.propertyName || undefined;
        this.code = data.code || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.status = data.status || 0; // 0: Inactive, 1: Active
        this.syncStatus = data.syncStatus || false;
        
        // FnB Portal Info (Read-only)
        this.openTime = data.openTime || undefined;
        this.closeTime = data.closeTime || undefined;
        this.zone = data.zone || undefined;
        this.restaurantType = data.restaurantType || undefined;
        this.cuisineType = data.cuisineType || undefined;

        // VPT Config
        this.onlineOrder = data.onlineOrder || false;
        this.shortDescription = data.shortDescription || '';
        this.description = data.description || '';
        this.menuFiles = data.menuFiles || [];
    }
}
